const normalizeUrl = (value: string) => value.replace(/\/+$/, "");

// Webpack DefinePlugin performs literal text replacement, so each
// process.env.* reference MUST appear as an explicit literal — a dynamic
// process.env[key] lookup will NOT be replaced at build time.

export const runtimeConfig = {
  apiUrl: normalizeUrl(process.env.API_URL || "https://erpapi.kaanpos.com"),
} as const;
